export default __webpack_public_path__ + "static/media/Abyssal Demon Pendant of Constitution.28412121.jpg";